import * as React from "react";
import styled, { keyframes } from "react-emotion";
import CirlceIcon from "../CircleIcon";
import { theme, mqMin, AbsOverflow } from "../../styles/theme";
import { black } from "../../styles/colors";
import { inject, observer } from "mobx-react";

const rot = keyframes`
  0% {
    transform: rotate(0deg);
  }
	100% {
    transform: rotate(360deg);
	}
`;

const IconWrap = styled.div`
  display: block;
  font-size: 3rem;
  cursor: pointer;
  z-index: 1010;
  position: fixed;
  top: -70px;
  right: -70px;
  transform: translateX(${props => (props.open ? `0` : "-100%")})
    translateY(${props => (props.open ? `0` : "-100%")}) rotate(-131deg);
  animation: ${props => (props.open ? `${rot} 3s ease infinite` : null)};
  transform-origin: center center;
`;

const MenuClose = ({ children, type, x = 0, y = 0, open, toggleMenu }) => {
  return (
    <IconWrap height={210} open={open} onClick={() => toggleMenu()}>
      <CirlceIcon text={"CLOSE ME"} height={210} />
    </IconWrap>
  );
};

export default inject(({ store }) => ({
  open: store.appStore.menu.open,
  toggleMenu: store.appStore.toggleMenu
}))(observer(MenuClose));



// WEBPACK FOOTER //
// ./src/components/MenuClose/index.js